var _path, _path2, _mask, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7676 12.7168V7.82033C12.7675 6.95115 12.4235 6.1165 11.8027 5.50588L11.7998 5.50295L9.55762 3.26858C9.46016 3.17156 9.30263 3.17171 9.20508 3.26858L6.95312 5.51272C6.33594 6.12769 5.9845 6.96508 5.98438 7.8301V12.7266C5.98415 13.1406 5.64845 13.4766 5.23438 13.4766C4.8203 13.4766 4.4846 13.1406 4.48438 12.7266V7.8301C4.4845 6.56113 4.99788 5.34283 5.89355 4.45022L8.14551 2.20608C8.82837 1.52566 9.93329 1.52575 10.6162 2.20608L12.8545 4.43655L13.0215 4.60842C13.8279 5.48637 14.2675 6.63442 14.2676 7.82033V12.7168C14.2673 13.1308 13.9316 13.4668 13.5176 13.4668C13.1037 13.4666 12.7678 13.1307 12.7676 12.7168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7529 12.4463L15.8291 12.4502C16.2074 12.4885 16.5029 12.8079 16.5029 13.1963C16.5029 13.5847 16.2074 13.9041 15.8291 13.9424L15.7529 13.9463H3.00781C2.5936 13.9463 2.25781 13.6105 2.25781 13.1963C2.25781 12.7821 2.5936 12.4463 3.00781 12.4463H15.7529Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_7518_3268",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55469 14.812C7.55469 15.8205 8.38011 16.643 9.39222 16.643C10.4043 16.643 11.2298 15.8205 11.2298 14.812"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55469 14.812C7.55469 15.8205 8.38011 16.643 9.39222 16.643C10.4043 16.643 11.2298 15.8205 11.2298 14.812",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 14.812C8.55469 14.2597 8.10697 13.812 7.55469 13.812C7.0024 13.812 6.55469 14.2597 6.55469 14.812H8.55469ZM12.2298 14.812C12.2298 14.2597 11.782 13.812 11.2298 13.812C10.6775 13.812 10.2298 14.2597 10.2298 14.812H12.2298ZM7.55469 14.812H6.55469C6.55469 16.3762 7.83121 17.643 9.39222 17.643V16.643V15.643C8.929 15.643 8.55469 15.2648 8.55469 14.812H7.55469ZM9.39222 16.643V17.643C10.9532 17.643 12.2298 16.3762 12.2298 14.812H11.2298H10.2298C10.2298 15.2648 9.85545 15.643 9.39222 15.643V16.643Z",
    fill: "white",
    mask: "url(#path-3-inside-1_7518_3268)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z",
    fill: "#FB7401"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C7 2.34315 5.65685 1 4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7V8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 6.20914 6.20914 8 4 8V7C5.65685 7 7 5.65685 7 4Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesActive);
export default __webpack_public_path__ + "static/media/MessagesActive.e7997db30376f29318bafd06828103f6.svg";
export { ForwardRef as ReactComponent };